import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type IFreshStrawState = {
  showFreshStrawQC: boolean;
};

const initialState: IFreshStrawState = {
  showFreshStrawQC: false,
};

const FreshStrawSlice = createSlice({
  name: 'FreshStraw',
  initialState,
  reducers: {
    updateShowFreshStrawQC: (state, action: PayloadAction<boolean>) => {
      state.showFreshStrawQC = action.payload;
    },
  },
});

export const { updateShowFreshStrawQC } = FreshStrawSlice.actions;

export default FreshStrawSlice.reducer;
